import { createSelector } from 'reselect';
import { getSuggestState } from 'src/selectors/getSuggestState';

export const getSuggestData = createSelector([
    getSuggestState,
], (state) => state.suggests);
